import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { rupiah } from "@/lib/format";
import { ShoppingBasket, Plus, Minus, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, open, setOpen, setQty, remove, subtotal, count } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md flex flex-col p-0" data-testid="cart-drawer-container">
        <SheetHeader className="p-6 pb-2 border-b border-[#E5DECF]">
          <SheetTitle className="font-display text-2xl flex items-center gap-2">
            <ShoppingBasket className="w-5 h-5 text-emerald-700" />
            Keranjang ({count})
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto p-6 space-y-3">
          {items.length === 0 && (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto rounded-full bg-emerald-50 flex items-center justify-center mb-4">
                <ShoppingBasket className="w-8 h-8 text-emerald-700" />
              </div>
              <p className="font-display font-bold text-lg">Keranjang masih kosong</p>
              <p className="text-sm text-stone-500 mt-1">Yuk isi dengan sembako & makanan hangat.</p>
            </div>
          )}
          {items.map((it) => (
            <div key={it.key} data-testid={`cart-item-${it.product_id}`} className="flex gap-3 p-2 rounded-2xl border border-[#E5DECF] bg-white">
              {it.image_url ? (
                <img src={it.image_url} alt={it.name} className="w-16 h-16 rounded-xl object-cover" />
              ) : (
                <div className="w-16 h-16 rounded-xl bg-stone-200 flex items-center justify-center text-2xl">🛒</div>
              )}
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm line-clamp-2">{it.name}</div>
                {it.variant_name && <div className="text-[10px] font-mono uppercase tracking-widest text-emerald-700 font-semibold">Varian: {it.variant_name}</div>}
                <div className="text-emerald-800 font-display font-bold text-sm mt-0.5">{rupiah(it.price)}</div>
                <div className="mt-2 flex items-center gap-2">
                  <button data-testid={`cart-item-decrement-${it.product_id}`} onClick={() => setQty(it.key, it.qty - 1)} className="w-7 h-7 rounded-full bg-emerald-700 text-white hover:bg-emerald-800 flex items-center justify-center">
                    <Minus className="w-3 h-3" />
                  </button>
                  <span className="text-sm font-bold w-6 text-center">{it.qty}</span>
                  <button data-testid={`cart-item-increment-${it.product_id}`} onClick={() => setQty(it.key, it.qty + 1)} className="w-7 h-7 rounded-full bg-emerald-700 text-white hover:bg-emerald-800 flex items-center justify-center">
                    <Plus className="w-3 h-3" />
                  </button>
                  <button data-testid={`cart-item-remove-${it.product_id}`} onClick={() => remove(it.key)} className="ml-auto text-rose-500 hover:text-rose-700">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="p-6 border-t border-[#E5DECF] space-y-3">
            <div className="flex items-baseline justify-between">
              <span className="text-sm text-stone-600">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-display font-black text-2xl text-emerald-800">{rupiah(subtotal)}</span>
            </div>
            <Button
              data-testid="cart-checkout-proceed-btn"
              onClick={() => { setOpen(false); navigate("/checkout"); }}
              className="w-full rounded-full bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-6 text-base"
            >
              Lanjut ke Checkout →
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
